import {
  FETCH_NAGRA_CANDIDATES_REQUEST,
  FETCH_NAGRA_CANDIDATES_SUCCESS,
  FETCH_NAGRA_CANDIDATES_FAILURE,
  FETCH_NAGRA_BATCH_REQUEST,
  FETCH_NAGRA_BATCH_SUCCESS,
  FETCH_NAGRA_BATCH_FAILURE,
  REMOVE_NAGRA_BATCH_CANDIDATE,
  FETCH_NAGRA_CANDIDATE_REQUEST,
  FETCH_NAGRA_CANDIDATE_SUCCESS,
  FETCH_NAGRA_CANDIDATE_FAILURE,
  UPDATE_NAGRA_CANDIDATE_REQUEST,
  UPDATE_NAGRA_CANDIDATE_SUCCESS,
  UPDATE_NAGRA_CANDIDATE_FAILURE,
  UPLOAD_NAGRA_SCREENSHOT_REQUEST,
  UPLOAD_NAGRA_SCREENSHOT_SUCCESS,
  UPLOAD_NAGRA_SCREENSHOT_FAILURE,
  SUBMIT_NAGRA_CANDIDATE_REQUEST,
  SUBMIT_NAGRA_CANDIDATE_SUCCESS,
  SUBMIT_NAGRA_CANDIDATE_FAILURE,
  FETCH_NAGRA_MANUAL_CANDIDATES_REQUEST,
  FETCH_NAGRA_MANUAL_CANDIDATES_SUCCESS,
  FETCH_NAGRA_MANUAL_CANDIDATES_FAILURE,
  CREATE_NAGRA_MANUAL_CANDIDATE_REQUEST,
  CREATE_NAGRA_MANUAL_CANDIDATE_SUCCESS,
  CREATE_NAGRA_MANUAL_CANDIDATE_FAILURE,
} from '../../../actions/actionTypes';

const initialState = {
  // List view
  candidates: [],
  total: 0,
  page: 1,
  limit: 20,
  loading: false,
  // Batch review
  batch: [],
  batchMessage: null,
  batchStatusTotals: null,
  batchActiveOperations: null,
  loadingBatch: false,
  // Single candidate detail
  candidate: null,
  saving: false,
  uploadingScreenshot: false,
  submitting: false,
  // Manual submission
  manualCandidates: [],
  manualTotal: 0,
  manualPage: 1,
  manualLoading: false,
  manualCreating: false,
  error: null,
};

function nagraCandidates(state = initialState, action) {
  switch (action.type) {
    case FETCH_NAGRA_CANDIDATES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_NAGRA_CANDIDATES_SUCCESS:
      return {
        ...state,
        loading: false,
        candidates: action.payload.candidates,
        total: action.payload.total,
        page: action.payload.page,
        limit: action.payload.limit,
      };
    case FETCH_NAGRA_CANDIDATES_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    case FETCH_NAGRA_BATCH_REQUEST:
      return { ...state, loadingBatch: true, error: null };
    case FETCH_NAGRA_BATCH_SUCCESS:
      return {
        ...state,
        loadingBatch: false,
        batch: action.payload.batch,
        batchMessage: action.payload.message,
        batchStatusTotals: action.payload.statusTotals ?? null,
        batchActiveOperations: action.payload.activeOperations ?? null,
      };
    case FETCH_NAGRA_BATCH_FAILURE:
      return { ...state, loadingBatch: false, error: action.payload.error };

    case REMOVE_NAGRA_BATCH_CANDIDATE:
      return {
        ...state,
        batch: state.batch.filter((c) => c.id !== action.payload.id),
      };

    case FETCH_NAGRA_CANDIDATE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_NAGRA_CANDIDATE_SUCCESS:
      return { ...state, loading: false, candidate: action.payload.candidate };
    case FETCH_NAGRA_CANDIDATE_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    case UPDATE_NAGRA_CANDIDATE_REQUEST:
      return { ...state, saving: true, error: null };
    case UPDATE_NAGRA_CANDIDATE_SUCCESS:
      return { ...state, saving: false, candidate: action.payload.candidate };
    case UPDATE_NAGRA_CANDIDATE_FAILURE:
      return { ...state, saving: false, error: action.payload.error };

    case UPLOAD_NAGRA_SCREENSHOT_REQUEST:
      return { ...state, uploadingScreenshot: true, error: null };
    case UPLOAD_NAGRA_SCREENSHOT_SUCCESS:
      return {
        ...state,
        uploadingScreenshot: false,
        candidate: state.candidate
          ? { ...state.candidate, screenshotS3Urls: action.payload.screenshotS3Urls }
          : state.candidate,
      };
    case UPLOAD_NAGRA_SCREENSHOT_FAILURE:
      return { ...state, uploadingScreenshot: false, error: action.payload.error };

    case SUBMIT_NAGRA_CANDIDATE_REQUEST:
      return { ...state, submitting: true, error: null };
    case SUBMIT_NAGRA_CANDIDATE_SUCCESS:
      return { ...state, submitting: false, candidate: action.payload.candidate };
    case SUBMIT_NAGRA_CANDIDATE_FAILURE:
      return { ...state, submitting: false, error: action.payload.error };

    case FETCH_NAGRA_MANUAL_CANDIDATES_REQUEST:
      return { ...state, manualLoading: true };
    case FETCH_NAGRA_MANUAL_CANDIDATES_SUCCESS:
      return {
        ...state,
        manualLoading: false,
        manualCandidates: action.payload.data ?? [],
        manualTotal: action.payload.total ?? 0,
        manualPage: action.payload.page ?? 1,
      };
    case FETCH_NAGRA_MANUAL_CANDIDATES_FAILURE:
      return { ...state, manualLoading: false, error: action.payload.error };

    case CREATE_NAGRA_MANUAL_CANDIDATE_REQUEST:
      return { ...state, manualCreating: true, error: null };
    case CREATE_NAGRA_MANUAL_CANDIDATE_SUCCESS:
      return { ...state, manualCreating: false };
    case CREATE_NAGRA_MANUAL_CANDIDATE_FAILURE:
      return { ...state, manualCreating: false, error: action.payload.error };

    default:
      return state;
  }
}

export default nagraCandidates;
